import {
  LoadingIconButton as LoadingIconButtonBase,
  type LoadingIconButtonProps,
} from "@clipboard-health/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function LoadingIconButton(props: Omit<LoadingIconButtonProps, "LinkComponent">) {
  return <LoadingIconButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
